/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  injectIntl,
  FormattedMessage,
} from 'react-intl';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import styles from './styles.scss';

const defaultProps = {
  description: null,
};
const propTypes = {
  description: React.PropTypes.node,
  pushState: React.PropTypes.func.isRequired,
};

class PageNoPerm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { pushState } = this.props;
    let { description } = this.props;
    if (_.isNil(description)) {
      description = (
        <div>
          <FormattedMessage
            id="lora.noperm.undercomm.trial"
            defaultMessage="lora.noperm.undercomm.trial"
          />
          <Link onClick={() => pushState('/billing')} className={styles.upgrade}>
            <FormattedMessage
              id="lora.noperm.undercomm.upgrade"
              defaultMessage="lora.noperm.undercomm.upgrade"
            />
            {' '}
            <i className="fa fa-arrow-circle-o-up" />
          </Link>
          <FormattedMessage
            id="lora.noperm.undercomm.upgradeto"
            defaultMessage="lora.noperm.undercomm.upgradeto"
          />
        </div>
      );
    }

    return (
      <div className={styles.noperm}>
        <h5><i className="fa fa-eye-slash" /></h5>
        <h5>
          <FormattedMessage
            id="lora.noperm"
            defaultMessage="lora.noperm"
          />
        </h5>
        <div className={styles.desc}>
          {description}
        </div>
      </div>
    );
  }
}

PageNoPerm.propTypes = propTypes;
PageNoPerm.defaultProps = defaultProps;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(PageNoPerm));




// WEBPACK FOOTER //
// ./src/components/PageNoPerm/index.jsx